// Query ids of the checkout profile detail tabs; the server names them GENERAL, PAYMENTS,
// DEPOSIT and DOCUMENTS, which lower-case to the first four.
export const CHECKOUT_PROFILE_TAB_IDS = {
  general: 'general',
  payments: 'payments',
  deposit: 'deposit',
  documents: 'documents',
  assignmentRules: 'assignment-rules',
} as const;
